import Immutable from 'immutable';

/**
 * todo: we need a better solution - see EVT-1687
 * Create an immutable map based on the passed in data.
 * NOTE: only a data type of object will be converted into a Map,
 * all other data will be ignored and an empty Map will be returned.
 * @param {Object|Immutable.Map} data - The data to turn into an Map.
 * @returns {Immutable.Map} Immutable Map
 */
export const createImmutableMap = (data) => {
    if (Immutable.Map.isMap(data)) {
        return data;
    } if (typeof data === 'object' && !Array.isArray(data)) {
        return Immutable.fromJS(data);
    }
    return Immutable.Map();
};
